export default __webpack_public_path__ + "static/media/placeholder_portfolio04-it-mobile.ea1c055f.png";